import request from '@/config/axios'

/**
 * Boss 圈 C 端文案配置（启动页 / 引导页 / 登录页 / 首页）。
 *
 * 数据落在 `bosscircle_config` 表的 `APP_COPY` 键里，整段是一个 JSON 字符串。
 * 后端接口：
 * - GET    /bosscircle/app-copy/get     取当前整段 JSON（未配置时返回内置默认）
 * - PUT    /bosscircle/app-copy/update  保存（body: { content: '<整段 JSON>' }）
 * - DELETE /bosscircle/app-copy/reset   恢复默认（删掉该租户的配置行）
 */
export const getAppCopy = () => request.get({ url: '/bosscircle/app-copy/get' })

export const updateAppCopy = (content: string) =>
  request.put({ url: '/bosscircle/app-copy/update', data: { content } })

export const resetAppCopy = () => request.delete({ url: '/bosscircle/app-copy/reset' })
